import { IParamsObject, IServerResponse } from "@/api/types";
import { AxiosResponse } from "axios";
import { axiosInstance } from "@/api/index";
import { API_REGISTRATIONS_URL } from "@/configs/global";
import { IRegistration } from "@/api/types/registrations";
import { FormattedItem } from "@/utils/CellsFromBff";

// Получение списка регистраций
export async function getRegistrations(params: IParamsObject): Promise<IServerResponse<FormattedItem<IRegistration>[]>> {
    return axiosInstance.request<IServerResponse<FormattedItem<IRegistration>[]>>({
        method: "GET",
        url: `${API_REGISTRATIONS_URL}/registrations`,
        params,
    })
        .then((response: AxiosResponse<IServerResponse<FormattedItem<IRegistration>[]>>) => response.data);
}
// Получение одной регистрации
export async function getRegistrationSingle(id: number): Promise<IServerResponse<IRegistration>> {
    return axiosInstance.request<IServerResponse<IRegistration>>({
        method: "GET",
        url: `${API_REGISTRATIONS_URL}/registrations/${id}`,
    })
        .then((response: AxiosResponse<IServerResponse<IRegistration>>) => response.data);
}
// Получение списка вопросов при регистрации
export async function getRegistrationQuestions(): Promise<IServerResponse<string[]>> {
    return axiosInstance.request<IServerResponse<string[]>>({
        method: "GET",
        url: `${API_REGISTRATIONS_URL}/registrations/survey-options/questions`,
    })
        .then((response: AxiosResponse<IServerResponse<string[]>>) => response.data);
}
// Получение списка ответов на вопрос при регистрации
export async function getRegistrationAnswers(question: string, params: IParamsObject): Promise<IServerResponse<string[]>> {
    return axiosInstance.request<IServerResponse<string[]>>({
        method: "GET",
        url: `${API_REGISTRATIONS_URL}/registrations/survey-options/answers?question=${question}`,
        params,
    })
        .then((response: AxiosResponse<IServerResponse<string[]>>) => response.data);
}


